import { Label } from "../../ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../ui/select";
import type { CollabProcedureType } from "../../../models/audit/collabPlanTypes";

interface ProcedureTypeFieldProps {
  procedureType: CollabProcedureType;
  onProcedureTypeChange: (procedureType: CollabProcedureType) => void;
  /** Why the type may not change at all (`procedureTypeHold`), or null. */
  typeHold: string | null;
  /** Why Direct may not be chosen (`directChoiceHold`), or null. */
  directHold: string | null;
}

/**
 * The Testing Table dialog's Procedure Type picker. It disables the choices
 * `directTableRule` holds and says why, since the server would refuse them on
 * Save.
 */
export const ProcedureTypeField = ({
  procedureType,
  onProcedureTypeChange,
  typeHold,
  directHold,
}: ProcedureTypeFieldProps) => {
  const hint = typeHold ?? directHold;

  return (
    <div className="space-y-2">
      <Label htmlFor="table-procedure-type">Procedure Type</Label>
      <Select
        value={procedureType}
        onValueChange={(v) => {
          if (v === "sample" || v === "direct") {
            onProcedureTypeChange(v);
          }
        }}
        disabled={typeHold !== null}
      >
        <SelectTrigger
          id="table-procedure-type"
          aria-describedby={hint ? "table-procedure-type-hold" : undefined}
        >
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="sample">Sample</SelectItem>
          <SelectItem value="direct" disabled={directHold !== null}>
            Direct
          </SelectItem>
        </SelectContent>
      </Select>
      {hint && (
        <p id="table-procedure-type-hold" className="text-xs text-stone-500">
          {hint}
        </p>
      )}
    </div>
  );
};
